import { combineReducers } from 'redux';
import accountInfo from './accountInfo';
import typeArray from "./typeArray"

export default combineReducers({
	accountInfo,
	typeArray
});